
import {watchGetSchools, watchUpdateUserSchool} from './schoolSearchSagas';

const schoolSearchSagas = [
  watchGetSchools,
  watchUpdateUserSchool
];

export default schoolSearchSagas;
